<div class="p-grid">
  <div class="p-col-12">
      <p-card header="Monitoramento das fontes de dados">
        <div style="margin-top: 1%; margin-bottom: 1%;">
          <button pButton (click)="limparCacheEMonitorarTudo()" type="button" label="Executar Monitoramento" class="p-button-success" title="Executar novamente o monitoramento"></button>
        </div>
        <p-table
          [multiSortMeta]="ds.ordenacoes"
          [value]="ds.entidades"
          [totalRecords]="ds.total"
          (onLazyLoad)="ds.carregar($event)"
          [lazy]="true"
          [(rows)]="ds.registros"
          [paginator]="true"
          responsive="true"
          sortField="extrator.orgaoJustica"
          sortMode="single"
          emptyMessage="Nenhum registro encontrado">
          <!-- ver a questão do paginator -->
          <ng-template pTemplate="header">
            <tr>
              <th pColumn="id"  style="width: 70px">Id</th> <!-- Eu troquei pSortedColumn por pColumn -->
              <th pColumn="nome" style="width: 300px;">Nome</th>
              <th pColumn="nome" style="text-align: center;">Conversor</th>
              <th pColumn="nome" style="text-align: center;">Extrator</th>
              <th pColumn="nome" style="text-align: center;">Prisma</th>
              <th pColumn="nome" style="text-align: center;">Iris</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-entity let-rowIndex="rowIndex">
              <tr *ngIf="rowGroupMetadata[entity.extrator.orgaoJustica.nome].index + firstRowInPage === rowIndex">
                  <td colspan="6" class="text-left">
                      <span class="p-text-bold p-ml-2">{{entity.extrator.orgaoJustica.nome}} ({{rowGroupMetadata[entity.extrator.orgaoJustica.nome].size}})</span>
                  </td>
              </tr>
            <tr>
                <td>{{entity.id}}</td>
                <td class="text-left">
                    <a [routerLink]="['/fonteDados/edicao/', entity.id]" title="Ir para a edição">{{entity.nome}}</a>
                    <br/><span style="font-size: 0.8em;"> Tipo: </span><span style="font-size: 0.7em; font-style: italic">{{entity.tipo}}</span>
                    <br/><span style="font-size: 0.8em;">URL: {{entity.url}}</span>
                    <br/><span style="font-size: 0.8em; font-style: italic">{{entity.extrator?.orgaoJustica?.nome}}</span>
                </td>
                <td class="td-monitoramento">
                      <span *ngIf="monitoramentos[entity.id].conversor.carregando">
                        <em class="pi pi-fw pi-spin pi-spinner"></em>
                      </span>
                      <ng-container *ngIf="!monitoramentos[entity.id].conversor.carregando">
                        <span *ngIf="monitoramentos[entity.id].conversor.isSituacaoFalha()">
                          <em class="pi pi-fw pi-times-circle text-danger"></em>
                        </span>
                        <span *ngIf="monitoramentos[entity.id].conversor.isSituacaoSucesso()">
                          <em class="pi pi-fw pi-check text-success p-text-bold"></em>
                        </span>

                        <div class="ativos">
                          <ng-container *ngFor="let ativo of monitoramentos[entity.id].conversor.ativos">
                            <div class="row">
                              <app-ativo-visualizador [ativo]="ativo"></app-ativo-visualizador>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                </td>

                <td class="td-monitoramento">
                      <span *ngIf="monitoramentos[entity.id].extrator.carregando">
                        <em class="pi pi-fw pi-spin pi-spinner"></em>
                      </span>
                      <ng-container *ngIf="!monitoramentos[entity.id].extrator.carregando">
                        <span *ngIf="monitoramentos[entity.id].extrator.isSituacaoFalha()">
                          <em class="pi pi-fw pi-times-circle text-danger"></em>
                        </span>
                        <span *ngIf="monitoramentos[entity.id].extrator.isSituacaoSucesso()">
                          <em class="pi pi-fw  p-text-bold text-success"></em>
                        </span>

                        <div class="ativos">
                          <ng-container *ngFor="let ativo of monitoramentos[entity.id].extrator.ativos">
                            <div class="row">
                              <app-ativo-visualizador [ativo]="ativo"></app-ativo-visualizador>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                </td>

                <td class="td-monitoramento">
                      <span *ngIf="monitoramentos[entity.id].prisma.carregando">
                        <em class="pi pi-fw pi-spin pi-spinner"></em>
                      </span>
                      <ng-container *ngIf="!monitoramentos[entity.id].prisma.carregando">
                        <span *ngIf="monitoramentos[entity.id].prisma.isSituacaoFalha()">
                          <em class="pi pi-fw pi-times-circle text-danger"></em>
                        </span>
                        <span *ngIf="monitoramentos[entity.id].prisma.isSituacaoSucesso()">
                          <em class="pi pi-fw pi-check p-text-bold text-success"></em>
                        </span>

                        <div class="ativos">
                          <ng-container *ngFor="let ativo of monitoramentos[entity.id].prisma.ativos">
                            <div class="row">
                              <app-ativo-visualizador [ativo]="ativo"></app-ativo-visualizador>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                </td>

                <td class="td-monitoramento">
                      <span *ngIf="monitoramentos[entity.id].iris.carregando">
                        <em class="pi pi-fw pi-spin pi-spinner"></em>
                      </span>
                      <ng-container *ngIf="!monitoramentos[entity.id].iris.carregando">
                        <span *ngIf="monitoramentos[entity.id].iris.isSituacaoFalha()">
                          <em class="pi pi-fw pi-times-circle text-danger"></em>
                        </span>
                        <span *ngIf="monitoramentos[entity.id].iris.isSituacaoSucesso()">
                          <em class="pi pi-fw pi-check p-text-bold text-success"></em>
                        </span>

                        <div class="ativos">
                          <ng-container *ngFor="let ativo of monitoramentos[entity.id].iris.ativos">
                            <div class="row">
                              <app-ativo-visualizador [ativo]="ativo"></app-ativo-visualizador>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
  </div>
</div>



